import React from 'react';
import renderHTML from 'react-render-html';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import SIPConnectMigrationTable from '../sip-connect-migration-table/sip-connect-migration-table';
import './sip-connect-service-details.css';

const SIPConnectServiceDetails = (props) => {
  const {
    siteId,
    siteServices,
    enterpriseTrunking,
    enterpriseTrunkingNumbers,
    migrateToEnterpriseTrunk,
    migrateToEnterpriseTrunkSelection,
    handleMigrateToEnterpriseTrunk,
    handlEnterpriseTrunkSelection,
    sipConnectServiceTermAuthorableContent: {
      enterpriseTrunkingPreText,
      enterpriseTrunkingPostText,
    },
    enterpriseTrunkingNumbersOption,
    enterpriseTrunkValidationTracking,
    formSubmitted,
  } = props;

  const { serviceDetailsHeading } = props.authorableContent;
  const siteServicesArray = [];

  siteServices.forEach((parentService) => {
    siteServicesArray.push({ type: parentService.type, number: parentService.number });

    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number });

        childService.auxList.forEach((auxService) => {
          siteServicesArray.push({ type: 'Auxillary', number: auxService });
        });
      });
    } else {
      parentService.auxList.forEach((auxService) => {
        siteServicesArray.push({ type: 'Auxillary', number: auxService });
      });
    }
  });

  return (
    <div className="sip-connect-service-section">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="service-heading" className="service-heading">{serviceDetailsHeading}</h2>
        </div>
      </div>
      {enterpriseTrunking && (
        <div className="row enterprise-trunk-text">
          <div className="col-12 pl-sm-0">
            {renderHTML(stripStartingAndEndingPTags(enterpriseTrunkingPreText))}
            {enterpriseTrunkingNumbers.filter(numbers => numbers !== 'REQUEST_CALL_BACK').join(',')}
            {renderHTML(stripStartingAndEndingPTags(enterpriseTrunkingPostText))}
          </div>
        </div>
      )}

      <SIPConnectMigrationTable
        siteServicesArray={siteServicesArray}
        sipConnectServiceDetails={props.authorableContent}
        siteId={siteId}
        enterpriseTrunking={enterpriseTrunking}
        enterpriseTrunkingNumbersOption={enterpriseTrunkingNumbersOption}
        migrateToEnterpriseTrunk={migrateToEnterpriseTrunk}
        migrateToEnterpriseTrunkSelection={migrateToEnterpriseTrunkSelection}
        handleMigrateToEnterpriseTrunk={handleMigrateToEnterpriseTrunk}
        handlEnterpriseTrunkSelection={handlEnterpriseTrunkSelection}
        enterpriseTrunkValidationTracking={enterpriseTrunkValidationTracking}
        formSubmitted={formSubmitted}
      />
    </div>
  );
};

export default SIPConnectServiceDetails;
